import { Breadcrumb, Button, Col, Drawer, Flex, Form, Input, InputNumber, notification, Popconfirm, Row, Select, Space, Table, Tag, theme, Typography } from 'antd';
import { FilterOutlined, HomeOutlined, SearchOutlined, DeleteOutlined, EyeOutlined, EditOutlined, LockOutlined, UnlockOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react'
import Highlighter from 'react-highlight-words';
import { useSelector } from 'react-redux';
import MasterDataAPI from '../../../restAPI/MasterDataAPI.js';
import validateForm from '../../../utils/FormValidation.js';
import validationRules from '../../../assets/validation/rules.js';
import FilterComponent from '../../../utils/FilterComponent.js';
import PaperCategoryAPI from '../../../restAPI/PaperCategoryAPI.js';
import CommonSkeletonLoader from '../../../helperComponents/CommonSkeleton/index.js';
import dayjs from 'dayjs';

const { Search, TextArea } = Input;
const { Text, Link } = Typography;


const columns3 = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: (text) => <div style={{ wordBreak: 'break-word' }}>{text}</div>,
    },
    {
        title: 'Designation',
        dataIndex: 'designation',
        render: (text) => <div style={{ wordBreak: 'break-word' }}>{text}</div>
    },
];

export default function ManageCommittee() {
    const { companyId, token, userCompany, role, userDetailsId } = useSelector(state => state.auth);
    
    const [payload, setPayload] = useState({
        name: "",
        committeeTypeId: "",
        secretaryId: "",
        assistantSecretaryId: "",
        description: "",
        members: [],
        status: false,
        created_at: null
    });
    const [paperCategoryPayload, setPaperCategoryPayload] = useState({
        name: "",
        order: 1
    })
    const [committeeMembers, setCommitteeMembers] = useState(({
        name: "",
        email: "",
        companyName: "",
        companyAddress: "",
        designation: "",
        mobileNumber: "",
        officeNumber: "",
        department: "",
        roleList: []
    }))
    const [btnPermission, setBtnPermission] = useState({
        "addCommittee": false,
        "editCommittee": false,
        "deleteCommittee": false,
        "viewCommittee": false,
    });

    const [fullScreenLoading, setFullScreenLoading] = useState(false)
    const [selectedCommitteeID, setSelectedCommitteeID] = useState("")
    const [selectedCommittee, setSelectedCommittee] = useState({})
    const [tempSecretary, setTempSecretary] = useState(null);
    const [tempAssistantSecretary, setTempAssistantSecretary] = useState(null);
    const [selectedPaperCategoryID, setSelectedPaperCategoryID] = useState("") 
    const [open, setOpen] = useState(false);
    const [childrenDrawer, setChildrenDrawer] = useState(false);
    const [addPaperCategoryDrawer, setAddPaperCategoryDrawer] = useState(false);
    const [committeeMemberDrawer, setCommitteeMemberDrawer] = useState(false)
    const [selectionType, setSelectionType] = useState('checkbox');

    const [actionState, setActionState] = useState('add');
    const [paperCategoryActionState, setPaperCategoryActionState] = useState('add');
    const [errors, setErrors] = useState({});
    const [manageCommitteeTableData, setManageCommitteeTableData] = useState([])
    const [tempManageCommitteeTableData, setTempManageCommitteeTableData] = useState([])
    const [paperCategoryTableData, setPaperCategoryTableData] = useState([])
    const [committeeData, setCommitteeData] = useState([])
    const [secretaryList, setSecretaryList] = useState([])
    const [userList, setUserList] = useState([])
    const [branchList, setBranchList] = useState([]);
    const [selectedBranchId, setSelectedBranchId] = useState(null);
    const [newMemberData, setNewMemberData] = useState([])
    const [companyUsersList, setCompanyUsersList] = useState([])
    const [selectedRow, setSelectedRow] = useState([])
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [drawerTableData, setDrawerTableData] = useState([])
    const [showPopconfirm, setShowPopconfirm] = useState(false);
    const [showSecondPopconfirm, setShowSecondPopconfirm] = useState(false);
    const [searchInputValue, setSearchInputValue] = useState("");
    const [filterValues, setFilterValues] = useState([]);
    const [openFIlter, setOpenFilter] = useState(false);
    const [assistantSecUserList, setAssistantSecUserList] = useState([])
    const [currentCompanyInfo, setCurrentCompanyInfo] = useState({})
    const [userRole, setUserRole] = useState(null)
    const [paginationOnMemberTable, setPaginationOnMemberTable] = useState({ current: 1, pageSize: 10 })
    const [isBranchMembersLoading, setIsBranchMembersLoading] = useState(false);
    const [isSingleCommitteeDataLoading, setIsSingleCommitteeDataLoading] = useState(false);
    const [saveButtonLoading, setSaveButtonLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [addNewMemberForm] = Form.useForm();
    const [addNewPaperCategoryForm] = Form.useForm();

    const [openViewCommittee, setOpenViewCommittee] = useState(false);

    const [api, contextHolder] = notification.useNotification();

    const [isSaveButtonLoading, setIsSaveButtonLoading] = useState(false)
    const loggedInUserDetailsId = userDetailsId ? String(userDetailsId) : '';
    const isSelectedCommitteeOwner = loggedInUserDetailsId !== '' && (
        loggedInUserDetailsId === String(selectedCommittee?.secretaryId || '') ||
        loggedInUserDetailsId === String(selectedCommittee?.assistantSecretaryId || '')
    );
    const canManageSelectedCommittee =
        userRole === 'Company Admin' || userRole === 'Admin' || isSelectedCommitteeOwner;

    const openNotificationWithIcon = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };

    useEffect(() => {
        setFullScreenLoading(true)
        const companyInfo = userCompany?.companyData?.find(company => company.companyId === companyId);
        setCurrentCompanyInfo(companyInfo);
        setSearchInputValue((prev) => (prev ? "" : prev));
    }, [companyId, userCompany])
    
    const formatCommitteeData = (committeeList) => {
        return committeeList.map(committee => {
            const assistantSecretary = committee.assistantSecretaryId ? committee?.members.find(member => member._id === committee.assistantSecretaryId) : null;
            const secretaryUser = committee.secretaryId ? committee?.members.find(member => member._id === committee.secretaryId) : null;
            // const assistantSecretary = userList.find(member => member.value === committee.assistantSecretaryId);
            // const secretaryUser = userList.find(member => member.value === committee.secretaryId);
            const committeeType = committeeData.find(item => item.value === committee.committeeTypeId);
            
            // Create searchable members string from members array
            const membersString = committee.members && Array.isArray(committee.members) 
                ? committee.members.map(member => member.name || '').filter(name => name).join(', ')
                : '';

            return {
                ...committee,
                assistantSecretary: assistantSecretary ? assistantSecretary.name : null,
                // assistantSecretary: assistantSecretary ? assistantSecretary.label : null,
                secretaryUser: secretaryUser ? secretaryUser.name : null,
                // committeeType: null,
                committeeType: committeeType ? committeeType.label : null,
                createdDate: dayjs(committee.created_at).format('YYYY-MM-DD'),
                members: membersString,
            };
        });
    };

    const extractMemberDetails = (membersIdArray) => {
        const matchedUsers = companyUsersList.filter(user => membersIdArray.includes(user.key))

        const transformedUsers = matchedUsers.map(user => ({
            key: user.key,
            name: user.name,
            user: user.name,
            designation: user.designation?.trim() ? user.designation : "N/A",
            email: user.email,
            mobileNumber: user.mobileNumber,
            companyAddress: user.companyAddress,
            companyName: currentCompanyInfo?.companyName,
            branch: user.branch ? user.branch.name : null,
            roleList: user.roleList.length > 0 ? [user.roleList[0]] : [],
            department: user.department ? user.departmentDetails.name : null
        }));
        return transformedUsers;
    }

    const  getCommitteeListByCompanyId = async () => {
        await MasterDataAPI.getCommitteeListDetailsByCompanyId(companyId, token)
            .then((res) => {
                if (res.data) {
                    const formattedData = formatCommitteeData(res.data);
                    setTempManageCommitteeTableData(formattedData);
                    setManageCommitteeTableData(formattedData);
                }
            })
            .catch((err) => {
                setTempManageCommitteeTableData([])
                setManageCommitteeTableData([])
                console.log("error in getCommitteeListByCompanyId :", err)
            })
            .finally(() => {
                setFullScreenLoading(false)
            })
    }

    const getCommitteeTypes = async () => {
        await MasterDataAPI.getCommitteeDataByCompanyId(companyId, token)
            .then((res) => {
                const activeCommittee = res?.data ? res?.data.data.filter(committee => committee.status).map(committee => {
                    return { label: committee.name, value: committee.id };
                }) : [];
                setCommitteeData(activeCommittee);

                // handler for screen loading when committee list 0
                if(activeCommittee.length === 0) {
                    setFullScreenLoading(false);
                }
            })
            .catch((err) => {
                console.log("Error :", err.message);
            })
    }

    const getUserList = async () => {
        await MasterDataAPI.getUsersDataByCompanyId(companyId, token)
            .then((res) => {
                if (res?.data) {
                    const tempUserList = res?.data ? res?.data
                        .filter(user => user.status).map(singleUser => {
                            return { label: singleUser.name, value: singleUser.id };
                        }) : [];
                    
                    // handler for screen loading when user list 0
                    if(tempUserList.length === 0) {
                        setFullScreenLoading(false);
                    }

                    const tempFullUserList = Array.isArray(res?.data)
                        ? res.data
                            .filter((user) =>
                                user.roles?.some(
                                    (role) => role.name === "Assistant Secretary"
                                )
                            )
                            .map((singleUser) => {
                                return {
                                    label: singleUser.name,
                                    value: singleUser.id,
                                };
                            })
                        : [];

                    const newMemberDataList = Array.isArray(res?.data)
                        ? res.data
                            .filter((user) => user.status)
                            .map((singleUser) => {
                                return {
                                    key: singleUser?.id,
                                    name: singleUser?.name,
                                    designation: singleUser?.designation,
                                    email: singleUser?.email,
                                    mobileNumber: singleUser?.personalNumber,
                                    companyAddress: singleUser?.address,
                                    branchId: singleUser?.branch?.id,
                                    branch: singleUser?.branch,
                                    roleList: singleUser?.roles,
                                    department: singleUser?.department?.id,
                                    departmentDetails: singleUser?.department,
                                };
                            })
                        : [];

                    const secretaries = Array.isArray(res?.data)
                        ? res.data.filter((user) => user.roles?.some((role) => role.name === "Secretary")).map((singleUser) => {
                            const roleNames = singleUser.roles.map(
                                (role) => role.name
                            );
                            return {
                                label: singleUser.name,
                                value: singleUser.id,
                                role: roleNames,
                            };
                        })
                        : [];

                    // set data for assistant sec Select
                    setAssistantSecUserList(tempFullUserList)

                    setUserList(tempUserList)

                    // set data for secretary Select
                    setSecretaryList(secretaries);
                    // set data for add new members drawer
                    setCompanyUsersList(newMemberDataList)
                }
            })
            .catch((err) => {
                console.log("Error :", err.message);
            })
    }

    const getBranchList = async () => {
        await MasterDataAPI.getBranchDataByCompanyId(companyId, token)
            .then((res) => {
                if (res) {
                    const activeBranches = res?.data ? res?.data.filter(branch => branch.status).map(singleBranch => {
                        return { label: singleBranch.name, value: singleBranch.id };
                    }) : [];
                    setBranchList(activeBranches);
                }
            })
            .catch((err) => {
                console.log("Error :", err.message);
            })
    }

    const getUserListByBranchId = async () => {
        await MasterDataAPI.getUserListByBranchId(selectedBranchId, companyId, token)
            .then((res) => {
                if (res && res.data && res.data.length > 0) {
                    const secretaryId = selectedCommittee?.secretaryId || tempSecretary;
                    const assistantSecretaryId = selectedCommittee?.assistantSecretaryId || tempAssistantSecretary;

                    const committeeMemberList = drawerTableData.map(item => item.key);

                    const tempUserList = res.data
                        .filter(user => user.status && secretaryId !== user.id && assistantSecretaryId !== user.id && !committeeMemberList.includes(user.id))
                        .map(singleUser => {
                            const selectedUserBranch = branchList.find(branch => branch.value === singleUser.branchId);
                            return {
                                key: singleUser?.id,
                                name: singleUser?.name,
                                designation: singleUser?.designation?.trim() ? singleUser?.designation : "N/A",
                                email: singleUser?.email || null,
                                mobileNumber: singleUser?.personalNumber,
                                companyAddress: singleUser?.address,
                                branch: selectedUserBranch?.label || "No branch",
                                companyName: userCompany?.companyData[0].companyName,
                                roleList: singleUser?.Roles,
                                department: singleUser?.departmentId
                            }
                        })
                    setNewMemberData(tempUserList);
                    setIsBranchMembersLoading(false);
                }
                else {
                    setNewMemberData([]);
                    setIsBranchMembersLoading(false);
                    console.log('No users found for the selected branch.');
                }
            })
            .catch((err) => {
                setNewMemberData([])
                setIsBranchMembersLoading(false);
                console.log("Error in getUserListByBranchId :", err)
            })
    }

    const getCommitteeDataByCommitteeId = async () => {
        await MasterDataAPI.getCommitteeDataByCommitteeId(selectedCommitteeID, companyId, token)
            .then((res) => {
                if (res) {
                    setPayload({
                        name: res.data.name,
                        committeeTypeId: res.data.committeeTypeId,
                        secretaryId: res.data.secretaryId,
                        assistantSecretaryId: res.data.assistantSecretaryId,
                        description: res.data.description,
                        status: res.data.status,
                        created_at: dayjs(res.data.created_at).format('YYYY-MM-DD')
                    })
                    const tempMembers = extractMemberDetails(res?.data?.members)
                    setDrawerTableData(tempMembers)
                    setIsSingleCommitteeDataLoading(false);
                }
            })
            .catch((err) => {
                setIsSingleCommitteeDataLoading(false);
                setPayload({
                    name: "",
                    committeeTypeId: "",
                    secretaryId: "",
                    assistantSecretaryId: "",
                    description: "",
                    members: [],
                    status: false,
                    created_at: null
                })
                console.log("error in getCommitteeDataByCommitteeId ", err)
            })
    }

    const getPaperCategoryDataByCommitteeId = async () => {
        if (userRole === "Secretary" || userRole === "Assistant Secretary") {
            try {
                const response = await PaperCategoryAPI.getPaperCategoryList(selectedCommitteeID, companyId, token);
                if (response.status === 200) {
                    setPaperCategoryTableData(response.data.data);
                }
            } catch (error) {
                console.log('Get paper category error :', error)
            }
        }
    }

    const getSinglePaperCategoryDataById = async () => {
        try {
            const response = await PaperCategoryAPI.getSinglePaperCategory(selectedPaperCategoryID, companyId, token);
            setPaperCategoryPayload({
                name: response.data.data.name,
                order: response.data.data.order
            })
        } catch (error) {
            console.log('Errors in getSInglePaperCategory :', error);
        }
    }

    useEffect(() => {
        if (role.length > 0) {
            setUserRole(role[0].roleName);
        }
    }, [role])

    useEffect(() => {
        setBtnPermission({
            "addCommittee": false,
            "editCommittee": false,
            "deleteCommittee": false,
            "viewCommittee": false,
        })
        if (role.length > 0) {
            role.forEach(value => {
                if (value.restricted) {
                    if (value.roleName === "Company Admin") {
                        setBtnPermission({
                            "addCommittee": true,
                            "editCommittee": true,
                            "deleteCommittee": true,
                            "viewCommittee": true,
                        })
                    } else if (value.roleName === "Admin") {
                        setBtnPermission({
                            "addCommittee": true,
                            "editCommittee": true,
                            "deleteCommittee": true,
                            "viewCommittee": true
                        })
                    }
                    else if (value.roleName === "Secretary" || value.roleName === "Assistant Secretary") {
                        setBtnPermission({
                            "addCommittee": false,
                            "editCommittee": true,
                            "deleteCommittee": false,
                            "viewCommittee": true,
                        })
                    }
                }
            });
        }
    }, [role])

    useEffect(() => {
        if (companyId) {
            getUserList();
            getCommitteeTypes();
            getBranchList();
        }
    }, [companyId])

    useEffect(() => {
        if (selectedBranchId) {
            setIsBranchMembersLoading(true);
            getUserListByBranchId();
        }
    }, [selectedBranchId])

    useEffect(() => {
        if( committeeData?.length > 0 && userList?.length > 0 ) {
            getCommitteeListByCompanyId();
        }
    }, [committeeData, userList])

    useEffect(() => {
        if (selectedCommitteeID) {
            setIsSingleCommitteeDataLoading(true);
            getCommitteeDataByCommitteeId();
            getPaperCategoryDataByCommitteeId()
        }
    }, [selectedCommitteeID]);

    useEffect(() => {
        if (selectedPaperCategoryID) {
            getSinglePaperCategoryDataById();
        }
    }, [selectedPaperCategoryID]);


    const editStatusHandler = async (records, type) => {
        const formData = {
            status: !records.status,
        }

        if (type === 'committee') {
            await MasterDataAPI.updateCommitteeStatus(records.id, formData, companyId, token)
                .then((res) => {
                    openNotificationWithIcon('success', 'Successful', `${res.message}`, 'bottomLeft');
                    getCommitteeListByCompanyId();
                })
                .catch((err) => {
                    if (err.response) {
                        openNotificationWithIcon('error', 'Committee status change failed', `${err.response.data.message}`, 'bottomLeft');
                    } else {
                        openNotificationWithIcon('error', 'Committee status change failed', `${err.message}`, 'bottomLeft');
                    }
                })
        }
        if (type === 'paperCategory') {
            await PaperCategoryAPI.updatePaperCategoryStatus(records.id, formData, companyId, token)
                .then((res) => {
                    openNotificationWithIcon('success', 'Successful', `${res.data.message}`, 'bottomLeft');
                    getPaperCategoryDataByCommitteeId();
                })
                .catch((err) => {
                    if (err.response) {
                        openNotificationWithIcon('error', 'Process failed', `${err.response.data.message}`, 'bottomLeft');
                    } else {
                        openNotificationWithIcon('error', 'Process failed', `Paper category status change failed`, 'bottomLeft');
                    }
                })
        }
    }

    const deleteHandler = async (records, type) => {
        if (type === 'committee') {
            await MasterDataAPI.deleteSingleCommittee(records.id, companyId, token)
                .then((res) => {
                    openNotificationWithIcon('success', 'Successful', `${res.message}`, 'bottomLeft');
                    getCommitteeListByCompanyId();
                })
                .catch((err) => {
                    if (err.response) {
                        openNotificationWithIcon('error', 'Committee deletion failed', `${err.response.data.message}`, 'bottomLeft');
                    } else {
                        openNotificationWithIcon('error', 'Committee deletion failed', `${err.message}`, 'bottomLeft');
                    }
                })
        }
        if (type === 'paperCategory') {
            await PaperCategoryAPI.deleteSinglePaperCategory(records.id, companyId, token)
                .then((res) => {
                    openNotificationWithIcon('success', 'Successful', `Paper category deleted successfully`, 'bottomLeft');
                    const newPaperCategoryListAfterDeleteOne = paperCategoryTableData
                        .filter(singlePaper => singlePaper.id !== records.id)
                    setPaperCategoryTableData(newPaperCategoryListAfterDeleteOne)
                })
                .catch((err) => {
                    if (err.response) {
                        openNotificationWithIcon('error', 'Process failed', `${err.response.data.message}`, 'bottomLeft');
                    } else {
                        openNotificationWithIcon('error', 'Process failed', `Paper category delete failed`, 'bottomLeft');
                    }
                })
        }
    }

    const showDrawer = () => {
        setOpen(true);
        setActionState('add');
    };
    const onClose = () => {
        setPayload({
            name: "",
            committeeTypeId: "",
            secretaryId: "",
            assistantSecretaryId: "",
            description: "",
            members: [],
            created_at: null
        })
        setSelectedCommitteeID("");
        setSelectedCommittee({});
        setTempSecretary(null);
        setTempAssistantSecretary(null);
        setOpen(false);
        setActionState('add');
        getCommitteeListByCompanyId();
        setErrors({});
        setDrawerTableData([]);
        setShowPopconfirm(false);
        setSelectedRowKeys([]);
        setSelectedRow([]);
    };

    const validateBeforeSubmit = (formName) => {
        let validateData = {};
        if (formName === 'committee') {
            validateData = {
                committeeName: payload.name,
                committeeTypeDropDown: payload.committeeTypeId,
                committeeSecretaryDropDown: payload.secretaryId,
                committeeAssistantSecDown: payload.assistantSecretaryId,
                committeeDescription: payload.description
            }
        }
        if (formName === 'paperCategory') {
            validateData = {
                paperCategoryName: paperCategoryPayload.name,
                paperCategoryOrder: paperCategoryPayload.order
            }
        }
        const validationResult = validateForm(validateData, validationRules);
        if (!validationResult.isValid) {
            const validationErr = validationResult.errors;
            const newErrors = {};
            Object.keys(validationErr).forEach((value) => {
                newErrors[value] = validationErr[value];
            })

            setErrors(newErrors);
            return false;
        } else {
            return true;
        }
    }

    function validateFormData(data) {
        const validationResult = validateForm(data, validationRules)
        if (!validationResult.isValid) {
            const err = validationResult.errors
            const newErrors = {};
            Object.keys(err).forEach((value) => {
                newErrors[value] = err[value];
            })
            setErrors(prev => ({ ...prev, ...newErrors }));
        } else {
            const keyData = Object.keys(data)[0]
            setErrors(prev => ({ ...prev, [keyData]: '' }))
        }
    }

    const rowSelection = {
        selectedRowKeys,
        onSelect: (record, selected) => {
            if (selected) {
                setSelectedRowKeys(prev => [...prev, record.key]);
                setSelectedRow(prev => [...prev, record]);
            } else {
                setSelectedRowKeys(prev => prev.filter(key => key !== record.key));
                setSelectedRow(prev => prev.filter(row => row.key !== record.key));
            }
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
            if (selected) {
                const validSelectedKeys = selectedRows
                    .filter(row => row.key !== undefined && row.key !== null)
                    .map(row => row.key);
                const validSelectedRows = selectedRows.filter(row => row.key !== undefined && row.key !== null);

                setSelectedRowKeys(validSelectedKeys);
                setSelectedRow(validSelectedRows);;
            } else {
                const validChangeKeys = changeRows
                    .filter(row => row.key !== undefined && row.key !== null)
                    .map(row => row.key);

                setSelectedRowKeys(prev => prev.filter(key => !validChangeKeys.includes(key)));
                setSelectedRow(prev => prev.filter(row => !validChangeKeys.includes(row.key)));
            }
        },
        getCheckboxProps: (record) => ({
            disabled: record.name === 'Disabled User',
            name: record.name,
        }),
    };

    const handleAddMembers = () => {
        if (selectedRow.length === 0) {
            setDrawerTableData([]);
        } else {
            const existingMembersMap = new Map(drawerTableData.map(member => [member.key, member]));

            // Update existing members and add new ones
            selectedRow.forEach(member => {
                if (existingMembersMap.has(member.key)) {
                    // Update the existing member
                    existingMembersMap.set(member.key, {
                        ...existingMembersMap.get(member.key),
                        ...member,
                        user: member.name,
                    });
                } else {
                    // Add new member
                    existingMembersMap.set(member.key, {
                        ...member,
                        user: member.name,
                    });
                }
            });

            // Convert the Map back to an array and update the state
            const updatedDrawerTableData = Array.from(existingMembersMap.values());
            setDrawerTableData(updatedDrawerTableData);
        }

        onChildrenDrawerClose();
    };

    const handleSingleMemberView = (records) => {
        showSingleMemberDrawer();
        setCommitteeMembers({
            ...committeeMembers,
            name: records.name,
            email: records.email,
            companyAddress: records.companyAddress,
            designation: records.designation,
            mobileNumber: records.mobileNumber,
            // roleList: roleOptions.label,
            roleList: records?.roleList[0].name,
            companyName: records.companyName,
            department: records.department
            // todo : fix this after API change
            // officeNumber: records.name,
        })
    }
    const handleSingleMemberRemove = (record) => {
        setDrawerTableData(prevState => prevState.filter(member => member.key !== record.key));
        setSelectedRowKeys(prevState => prevState.filter(key => key !== record.key));
        setSelectedRow(prevState => prevState.filter(row => row.key !== record.key));
    }

    const editHandler = (records => {
        setSelectedCommitteeID(records.id);
        setSelectedCommittee(records);
        setOpen(true);
        setActionState('edit');
    })

    const editPaperCategoryHandler = (records) => {
        setSelectedPaperCategoryID(records.id)
        setAddPaperCategoryDrawer(true);
        setPaperCategoryActionState('edit')
    }

    const viewSingleCommittee = (record) => {
        setOpenViewCommittee(true);
        setSelectedCommitteeID(record.id);
        setSelectedCommittee(record);
        setActionState('view');
    };

    const onCloseViewCommittee = () => {
        setActionState('add');
        setOpenViewCommittee(false);
        setSelectedCommitteeID("");
        setSelectedCommittee({});
        setPayload({
            name: "",
            committeeTypeId: "",
            secretaryId: "",
            assistantSecretaryId: "",
            description: "",
            members: [],
            created_at: null
        });
        setDrawerTableData([])
    };

    const viewSinglePaperCategory = (records => {
        setSelectedPaperCategoryID(records.id);
        setAddPaperCategoryDrawer(true);
        setPaperCategoryActionState('view')
    })
    
    const resetCommitteeFormAndState = () => {
        setPayload({
            name: "",
            committeeTypeId: "",
            secretaryId: "",
            assistantSecretaryId: "",
            description: "",
            members: [],
            created_at: null
        });
       
        setSelectedCommitteeID("");
        setSelectedCommittee({});
        setTempSecretary(null);
        setTempAssistantSecretary(null);
        
        setActionState('add');
        setErrors({});
        setDrawerTableData([]);
        setShowPopconfirm(false);
        setSelectedRowKeys([]);
        setSelectedRow([]);
    };
    
    
    const helperFunctionForUpdateCommittee = async () => {
        try {
            setOpen(false);
            setFullScreenLoading(true);
            const response = await MasterDataAPI.getCommitteeListDetailsByCompanyId(companyId, token);

            if (response.data) {
                const formattedData = formatCommitteeData(response.data);
                setManageCommitteeTableData(formattedData);                
                handleFilterSearchFunctionWithData(filterValues, formattedData);
            }
        } catch (error) {
            setTempManageCommitteeTableData([]);
            setManageCommitteeTableData([]);
            setFullScreenLoading(false);
        } finally {
            resetCommitteeFormAndState();
            setFullScreenLoading(false);
        }

    };

    const handleSubmit = async () => {
        setIsSaveButtonLoading(true);
        const membersArray = drawerTableData.length > 0 ? drawerTableData.map(item => item.key) : [];

        const sentPayload = {
            ...payload,
            members: membersArray
        }

        if (actionState === 'add') {
            await MasterDataAPI.createCommittee(sentPayload, companyId, token)
                .then((response) => {
                    openNotificationWithIcon('success', "Successful", `${response.message}`, 'bottomLeft');
                    setIsSaveButtonLoading(false);
                    onClose();
                })
                .catch((err) => {
                    setIsSaveButtonLoading(false);
                    console.log('error in add :', err)
                    if (err.response) {
                        openNotificationWithIcon('error', 'Committee creation failed', `${err.response.data.message}`, 'bottomLeft');
                    } else {
                        openNotificationWithIcon('error', 'Committee creation failed', `${err.message}`, 'bottomLeft');
                    }
                })
        }

        if (actionState === "edit") {
            try {
                const response = await MasterDataAPI.updateSingleCommittee(selectedCommitteeID, sentPayload, companyId, token);                
                openNotificationWithIcon('success', 'Successful', response.message, 'bottomLeft');
                helperFunctionForUpdateCommittee();
            } catch (error) {
                const userMessage = error.displayMessage || 'Unable to update committee. Please try again.'
                openNotificationWithIcon('error', 'Committee update failed', userMessage, 'bottomLeft');
                console.log('error in edit committee :', error);
            } finally {
                setIsSaveButtonLoading(false);
            }          
        }
    }

    const handlePaperCategorySave = async () => {
        try {
            let response;
            if (paperCategoryActionState === 'add') {
                response = await PaperCategoryAPI.createPaperCategory(selectedCommitteeID, paperCategoryPayload, companyId, token);
            } else if (paperCategoryActionState === 'edit') {
                response = await PaperCategoryAPI.updateSinglePaperCategory(selectedPaperCategoryID, paperCategoryPayload, companyId, token);
            }

            if (response.status === 200) {
                const successMessage = paperCategoryActionState === 'add' ? 'Paper category created.' : 'Paper category updated.';
                openNotificationWithIcon('success', 'Successful', successMessage, 'bottomLeft');
                getPaperCategoryDataByCommitteeId();
                onAddPaperCategoryDrawerClose();
                setSaveButtonLoading(false)
            } else {
                setSaveButtonLoading(false)
            }
        } catch (error) {
            const errorMessage = error.response ? error.response.data.message : error.message;
            openNotificationWithIcon('error', 'Operation failed', errorMessage, 'bottomLeft');
            console.log('Error in handlePaperCategorySave : ', error);
        } finally {
            setSaveButtonLoading(false)
            setShowSecondPopconfirm(false);
        }
    };

    const handleCreateUpdateClick = (e) => {
        e.preventDefault();
        setShowPopconfirm(false);
        if (validateBeforeSubmit('committee')) {
            //setShowPopconfirm(true)
            handleSubmit();
        } else {
            setShowPopconfirm(false)
        }
    }

    const handlePaperCategoryForm = (e) => {
        e.preventDefault();
        let validation = validateBeforeSubmit('paperCategory');

        if (paperCategoryActionState === 'add' && validation) {
            setSaveButtonLoading(true)
            handlePaperCategorySave();
        }
        else {
            if (validation) {
                setShowSecondPopconfirm(true)
            } else {
                setShowSecondPopconfirm(false)
            }
        }
    }

    const showChildrenDrawer = () => {
        setChildrenDrawer(true);
        if (setShowPopconfirm) { setShowPopconfirm(false) }
    };
    const onChildrenDrawerClose = () => {
        setChildrenDrawer(false);
        setSelectedBranchId(null);
        setNewMemberData([]);
        setSelectedRowKeys([]);
        setSelectedRow([]);
        addNewMemberForm.resetFields();
        setPaginationOnMemberTable({ current: 1, pageSize: 10 });
    };

    const showAddPaperCategoryDrawer = () => {
        const maxOrderNumber = paperCategoryTableData.reduce((max, item) => {
            return item.order > max ? item.order : max;
        }, 0)
        setPaperCategoryPayload({
            order: maxOrderNumber + 1
        })
        setAddPaperCategoryDrawer(true);
        setPaperCategoryActionState('add');
    };
    const onAddPaperCategoryDrawerClose = () => {
        setPaperCategoryPayload({
            name: "",
            order: 1
        })
        setAddPaperCategoryDrawer(false);
        setPaperCategoryActionState('add');
        setErrors({});
        setShowSecondPopconfirm(false);
        setSelectedPaperCategoryID('');
    };

    const showSingleMemberDrawer = () => {
        setCommitteeMemberDrawer(true);
        if (setShowPopconfirm) { setShowPopconfirm(false) }
    };
    const onSingleMemberDrawerClose = () => {
        setCommitteeMemberDrawer(false);
    };

    const showFilterDrawer = () => {
        setOpenFilter(true);
    }
    const onCloseFilter = () => {
        setOpenFilter(false);
    }

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    
    
    const columns = [
        {
            title: 'Committee Code',
            dataIndex: 'code',
            key: 'code',
        },
        {
            title: 'Committee Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Committee Type',
            dataIndex: 'committeeType',
            key: 'committeeType',
        },
        {
            title: 'Created Date',
            dataIndex: 'createdDate',
            key: 'createdDate',
        },
        {
            title: 'Secretary',
            dataIndex: 'secretaryUser',
            key: 'secretaryUser',
        },
        {
            title: 'Assistant Secretary',
            dataIndex: 'assistantSecretary',
            key: 'assistantSecretary',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            fixed: 'right',
            render: (_, record) => (
                record.status ? (<Tag color='purple' style={{ width: 90, textAlign: 'center' }}>Active</Tag>) : (<Tag color='warning' style={{ width: 90, textAlign: 'center' }}>Inactive</Tag>)
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            fixed: 'right',
            render: (_, record) => (
                <Flex gap="small" justify="center" align="center" vertical>
                    <Flex gap="middle" wrap="wrap">
                        {btnPermission.editCommittee && <Button
                            type="primary"
                            disabled={
                                !record.status ||
                                !(
                                    userRole === 'Company Admin' ||
                                    userRole === 'Admin' ||
                                    (loggedInUserDetailsId !== '' && loggedInUserDetailsId === String(record?.secretaryId || '')) ||
                                    (loggedInUserDetailsId !== '' && loggedInUserDetailsId === String(record?.assistantSecretaryId || ''))
                                )
                            }
                            icon={<EditOutlined />}
                            size='small'
                            onClick={() => editHandler(record)} />
                        }
                        {btnPermission.viewCommittee && <Button icon={<EyeOutlined />} size='small' onClick={() => viewSingleCommittee(record)} />}

                        {/* status change icon */}
                        {btnPermission.deleteCommittee && (
                            <><Popconfirm
                                //title="Do you want to change the status?"
                                title={record.status ? "Do you want to inactivate the committee?" : "Do you want to reactivate the committee?"}
                                onConfirm={() => editStatusHandler(record, 'committee')}
                                onCancel={() => openNotificationWithIcon('error', 'Abort', `Status update cancelled`, 'bottomLeft')}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button
                                    icon={record.status ? <LockOutlined /> : <UnlockOutlined />}
                                    size='small'
                                />
                            </Popconfirm>

                                {/* delete icon */}
                                <Popconfirm
                                    title="Do you want to delete this committee?"
                                    onConfirm={() => deleteHandler(record, 'committee')}
                                    onCancel={() => openNotificationWithIcon('error', 'Abort', `Delete cancelled`, 'bottomLeft')}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button danger type="primary" icon={<DeleteOutlined />} size='small' disabled={record.status} />
                                </Popconfirm>
                            </>
                        )}
                    </Flex>
                </Flex>
            ),
        },
    ];

    const paperCategoryTableColumns = [
        {
            title: 'Order',
            dataIndex: 'order',
            key: 'order',
        },
        {
            title: 'Paper Category Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            fixed: 'right',
            render: (_, record) => (
                record.status ? (<Tag color='purple' style={{ width: 90, textAlign: 'center' }}>Active</Tag>) : (<Tag color='warning' style={{ width: 90, textAlign: 'center' }}>Inactive</Tag>)
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            fixed: 'right',
            render: (_, record) => (
                <Flex gap="small" justify="center" align="center" vertical>
                    <Flex gap="middle" wrap="wrap">
                        <Button type="primary" disabled={!record.status || actionState === 'view'} icon={<EditOutlined />} size='small' onClick={() => editPaperCategoryHandler(record)} />

                        <Button icon={<EyeOutlined />} disabled={actionState === 'view'} size='small' onClick={() => viewSinglePaperCategory(record)} />

                        {/* status change icon */}
                        <Popconfirm
                            title={record.status ? "Do you want to inactivate the paper category?" : "Do you want to reactivate the paper category?"}
                            onConfirm={() => editStatusHandler(record, 'paperCategory')}
                            onCancel={() => openNotificationWithIcon('error', 'Abort', `Status update cancelled`, 'bottomLeft')}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button
                                icon={record.status ? <LockOutlined /> : <UnlockOutlined />}
                                size='small'
                                disabled={actionState === 'view'}
                            />
                        </Popconfirm>

                        {/* delete icon */}
                        <Popconfirm
                            title="Do you want to delete this paper category?"
                            onConfirm={() => deleteHandler(record, 'paperCategory')}
                            onCancel={() => openNotificationWithIcon('error', 'Abort', `Delete cancelled`, 'bottomLeft')}
                            okText="Yes"
                            cancelText="No">
                            <Button danger type="primary" icon={<DeleteOutlined />} size='small' disabled={record.status || actionState === 'view'} />
                        </Popconfirm>
                    </Flex>
                </Flex>
            ),
        },
    ];

    const filterDataByCriteria = (data, criteria) => {
        return data.filter(item => {
            return criteria.every(({ key, value }) => {
                if (!item[key] || !value) return false;

                const itemValue = item[key].toString().toLowerCase();
                const lowerCasePrefix = value.toLowerCase();
                return itemValue.includes(lowerCasePrefix);
            });
        });
    }

    const handleSearchFunction = (value) => {        
        if (value) {
            if (filterValues.length > 0) {
                const filterData = filterCommitteeListBySearchQuery(value,tempManageCommitteeTableData);               
                setTempManageCommitteeTableData(filterData);
            } else {
                const filteredData = filterCommitteeListBySearchQuery(value,manageCommitteeTableData);               
                setTempManageCommitteeTableData(filteredData);
            }
        }
        else {
            if (filterValues.length > 0) {
                const filterData = filterDataByCriteria(manageCommitteeTableData, filterValues);
                setTempManageCommitteeTableData(filterData);
            } else {
                setTempManageCommitteeTableData(manageCommitteeTableData);
            }
        }
    }

    const handleFilterSearchFunction = (value) => {
        if (value) {            
            if (searchInputValue.length > 0) {
                const filterData = filterCommitteeListBySearchQuery(searchInputValue,manageCommitteeTableData);     
                const filterData2 = filterDataByCriteria(filterData, value);
                setTempManageCommitteeTableData(filterData2);
            } else {
                const filterData = filterDataByCriteria(manageCommitteeTableData, value);
                setTempManageCommitteeTableData(filterData);
            }
        }
        else {
            if (searchInputValue?.length > 0) {
                const filteredData = filterCommitteeListBySearchQuery(searchInputValue,manageCommitteeTableData);     
                setTempManageCommitteeTableData(filteredData);
            }
            else {
                setTempManageCommitteeTableData(manageCommitteeTableData);
            }
        }
    }
    
    const handleRemoveTag = (key) => {
        setFilterValues(prev =>
            prev.filter(item => item.key !== key)
        );
    }


    const filterCommitteeListBySearchQuery = (query,committeeList) => {
        return committeeList.filter(committee =>
            (committee.code || '').toLowerCase().includes(query.toLowerCase()) ||
            (committee.name || '').toLowerCase().includes(query.toLowerCase()) ||
            (committee.committeeType || '').toLowerCase().includes(query.toLowerCase()) ||
            (committee.secretaryUser || '').toLowerCase().includes(query.toLowerCase()) ||
            (committee.assistantSecretary || '').toLowerCase().includes(query.toLowerCase()) ||
            (committee.createdDate || '').toLowerCase().includes(query.toLowerCase())
          );
    }

    const handleFilterSearchFunctionWithData = (value, dataToFilter) => {        
        if (value) {                    
            if (searchInputValue.length > 0) {  
                const filterData = filterCommitteeListBySearchQuery(searchInputValue,dataToFilter);                                       
                const filterData2 = filterDataByCriteria(filterData, value);
                setTempManageCommitteeTableData(filterData2);
            } else {
                if(Array.isArray(value) && value.length === 0){                    
                    setTempManageCommitteeTableData(dataToFilter);
                    return;
                }                
                const filterData = filterDataByCriteria(dataToFilter, value);
                setTempManageCommitteeTableData(filterData);
            }
        }
        else {            
            if (searchInputValue?.length > 0) {      
                const filteredData = filterCommitteeListBySearchQuery(searchInputValue,dataToFilter);                         
                setTempManageCommitteeTableData(filteredData);
            }
            else {                
                setTempManageCommitteeTableData(dataToFilter);
            }
        }
    }

    useEffect(() => {
        handleSearchFunction(searchInputValue)
        setCurrentPage(1); // Reset to page 1 when search changes
    }, [searchInputValue])

    useEffect(() => {
        handleFilterSearchFunction(filterValues);
        setCurrentPage(1); // Reset to page 1 when filters change
    }, [filterValues])

    const columns2 = [
        {
            title: 'User',
            dataIndex: 'user',
            key: 'user',
        },
        {
            title: 'Branch',
            dataIndex: 'branch',
            key: 'branch',
        },
        {
            title: 'Designation',
            dataIndex: 'designation',
            key: 'designation',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            fixed: 'right',
            render: (_, record) => (
                <Flex gap="small" justify="center" align="center" vertical>
                    <Flex gap="middle" wrap="wrap">
                        {actionState === 'view' && (
                            <Button icon={<EyeOutlined onClick={() => handleSingleMemberView(record)} />} size='small' />
                        )}
                        {
                            <Button
                                danger
                                type="primary"
                                icon={<DeleteOutlined />}
                                size='small'
                                onClick={() => handleSingleMemberRemove(record)}
                                disabled={
                                    actionState === 'view' ||
                                    record.key === selectedCommittee?.secretaryId ||
                                    record.key === selectedCommittee?.assistantSecretaryId ||
                                    !(
                                        (
                                            canManageSelectedCommittee
                                        )
                                    )
                                }
                            />
                        }
                    </Flex>
                </Flex>
            ),
        },
    ];

    

    const filterTags = filterValues.filter(filterObject => filterObject.value.trim() !== "");

    return (
        <>
            <Flex gap={20} justify='space-between' align='center' style={{
                margin: '16px',
                padding: '16px 24px',
                // minHeight: 280,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Breadcrumb
                    items={[
                        {
                            // href: '/web/Home',
                            title: <HomeOutlined />,
                        },
                        {
                            // href: '',
                            title: 'Meeting Management',
                        },
                        {
                            title: 'Manage Committee',
                        },
                    ]}
                />
                <Flex justify='center' align='center' gap={12}>
                    <Flex justify='center' align='center' gap={12}>
                        <Button
                            onClick={showFilterDrawer}
                            icon={
                                <FilterOutlined
                                    style={{ paddingLeft: 8, paddingRight: 8 }}
                                />
                            }
                        />

                        <Search
                            placeholder="Search"
                            value={searchInputValue}
                            // enterButton
                            onChange={(e) => setSearchInputValue(e.target.value)}
                        />
                    </Flex>
                    {btnPermission.addCommittee && (
                        <Button type="primary" onClick={showDrawer} >Add New</Button>
                    )}
                    {/* {!(role.includes('Secretary') || role.includes('Assistant Secretary')) && <Button type="primary" onClick={showDrawer} >Add New</Button>} */}
                </Flex>

            </Flex>
            <div style={{
                margin: '16px',
            }}>
                {
                    filterTags.length !== 0 &&
                    <Flex align='center' gap={12}>
                        {
                            filterTags.map(item => (
                                <Tag
                                    bordered={false}
                                    closable
                                    color='success'
                                    key={item?.key}
                                    onClose={() => handleRemoveTag(item?.key)}
                                >
                                    {item?.value}
                                </Tag>
                            ))
                        }
                    </Flex>
                }
            </div>
            <div style={{
                margin: '16px',
                padding: 24,
                minHeight: "78svh",
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                {/* Committee list Table for the selected company. */}
                {
                    fullScreenLoading ? <CommonSkeletonLoader itemCount={2} /> : (
                        <Table
                            columns={columns}
                            dataSource={tempManageCommitteeTableData}
                            scroll={{ x: 'max-content' }}
                            pagination={{
                                current: currentPage,
                                pageSize,
                                onChange: (page, size) => {
                                    setCurrentPage(page);
                                    setPageSize(size);
                                },
                                onShowSizeChange: (current, size) => {
                                    setCurrentPage(1);
                                    setPageSize(size);
                                },
                                showSizeChanger: true,
                                pageSizeOptions: ['10', '20', '50', '100'],
                                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                selectProps: {
                                    showSearch: false,
                                    inputReadOnly: true,
                                    onInputKeyDown: (e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    },
                                    onKeyDown: (e) => {
                                        // Allow only arrow keys, Enter, Escape, Tab
                                        if (!['ArrowUp', 'ArrowDown', 'Enter', 'Escape', 'Tab'].includes(e.key)) {
                                            e.preventDefault();
                                        }
                                    }
                                }
                            }}
                        />
                    )
                }
                <Drawer
                    title={actionState === 'add' ? "Add Committee" : actionState === "view" ? "View Committee" : "Update Committee"}
                    onClose={onClose}
                    open={open}
                    size='large'
                    // placement='bottom'
                    footer={[
                        <Flex justify='flex-end' align='center' gap='large'>
                            {
                                actionState === 'view' ? <></> : <>
                                    <Button onClick={onClose}>
                                        Cancel
                                    </Button>
                                </>
                            }
                            <Popconfirm
                                title={`Do you want to ${actionState === "add" ? "create" : "update"} the committee?`}
                                open={showPopconfirm}
                                onConfirm={() => handleSubmit()}
                                onCancel={() => {
                                    setShowPopconfirm(false)
                                    openNotificationWithIcon('error', 'Abort', `${actionState === "add" ? "Create" : "Update"} cancelled`, 'bottomLeft')
                                }}
                                okText="Yes"
                                cancelText="No"
                            >
                                {actionState === 'view' ? <></> : <>
                                    <Button
                                        type="primary"
                                        onClick={handleCreateUpdateClick}
                                        disabled={actionState === 'view' ? true : false}
                                        loading={isSaveButtonLoading}
                                    >
                                        {actionState === "add" ? "Create" : "Update"}
                                    </Button>
                                </>}
                            </Popconfirm>
                        </Flex>
                    ]
                    }
                    extra={
                        <Flex justify='center' align='center' gap={16}>
                           
                           
                            {/* {
                                !(actionState === 'edit' && userRole === 'Company Admin') && actionState !== "view" && (
                                    <Button type='primary' onClick={showChildrenDrawer} disabled={actionState === 'view'}>Add New Members</Button>
                                )
                            } */}
                        </Flex>
                    }
                >
                    <Form layout="vertical">
                        <Row gutter={12}>
                            <Col span={12}>
                                <Form.Item
                                    validateStatus={errors.committeeName ? 'error' : ''}
                                    help={errors.committeeName || ''}
                                    label="Committee Name"
                                    required
                                >
                                    <Input
                                        placeholder='Committee name'
                                        onChange={(e) => {
                                            const validateData = {
                                                committeeName: e.target.value
                                            }
                                            validateFormData(validateData)
                                            setPayload(prev => ({
                                                ...prev,
                                                name: e.target.value
                                            }))
                                        }}
                                        value={payload["name"]}
                                        autoComplete='new-name'
                                        disabled={actionState === 'view' || (userRole === "Secretary" || userRole === "Assistant Secretary")}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Committee Type"
                                    validateStatus={errors.committeeTypeDropDown ? 'error' : ''}
                                    help={errors.committeeTypeDropDown || ""}
                                    required
                                >
                                    <Select
                                        showSearch
                                        options={committeeData}
                                        placeholder="Select a committee"
                                        allowClear={true}
                                        onChange={(value) => {
                                            const validateDate = {
                                                committeeTypeDropDown: value
                                            }
                                            validateFormData(validateDate)
                                            setPayload(prev => ({
                                                ...prev,
                                                committeeTypeId: value
                                            }))
                                        }}
                                        value={payload["committeeTypeId"]}
                                        disabled={actionState === 'view' || (userRole === "Secretary" || userRole === "Assistant Secretary")}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={12}>
                            <Col span={12}>
                                <Form.Item
                                    label="Secretary"
                                    validateStatus={errors.committeeSecretaryDropDown ? 'error' : ''}
                                    help={errors.committeeSecretaryDropDown || ""}
                                    required
                                >
                                    <Select
                                        showSearch
                                        options={secretaryList}
                                        placeholder="Select a secretary"
                                        // allowClear={true}
                                        onChange={(value) => {
                                            const validateDate = {
                                                committeeSecretaryDropDown: value
                                            }
                                            validateFormData(validateDate)
                                            setPayload(prev => ({
                                                ...prev,
                                                secretaryId: value
                                            }))
                                            setTempSecretary(value);
                                            // handleAddMembersFromSelect(value);
                                        }}
                                        value={payload["secretaryId"]}
                                        disabled={actionState === 'view' || (userRole === "Secretary" || userRole === "Assistant Secretary")}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Assistant Secretary"
                                    validateStatus={errors.committeeAssistantSecDown ? 'error' : ''}
                                    help={errors.committeeAssistantSecDown || ""}
                                    required
                                >
                                    <Select
                                        showSearch
                                        options={assistantSecUserList}
                                        placeholder="Select a user"
                                        // allowClear={true}
                                        onChange={(value) => {
                                            const validateDate = {
                                                committeeAssistantSecDown: value
                                            }
                                            validateFormData(validateDate)
                                            setPayload(prev => ({
                                                ...prev,
                                                assistantSecretaryId: value
                                            }))
                                            setTempAssistantSecretary(value)
                                            // handleAddMembersFromSelect(value);
                                        }}
                                        value={payload["assistantSecretaryId"]}
                                        disabled={actionState === 'view' || (userRole === "Secretary" || userRole === "Assistant Secretary")}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Form.Item
                                    label="Committee Description"
                                    validateStatus={errors.committeeDescription ? 'error' : ''}
                                    help={errors.committeeDescription || ""}
                                >
                                    <TextArea
                                        placeholder='Committee description'
                                        value={payload["description"]}
                                        autoComplete='new-description'
                                        onChange={(e) => {
                                            const validateData = {
                                                committeeDescription: e.target.value
                                            }
                                            validateFormData(validateData)
                                            setPayload(prev => ({
                                                ...prev,
                                                description: e.target.value
                                            }))
                                        }}
                                        disabled={actionState === 'view' || (userRole === "Secretary" || userRole === "Assistant Secretary")}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    {
                        (
                            actionState !== 'view' && canManageSelectedCommittee
                        ) && <>
                            <Button 
                                type='primary' 
                                style={{float:'right',}} 
                                onClick={showChildrenDrawer} 
                                disabled={actionState === 'view'}
                            >
                                Add New Members
                            </Button>
                        </>
                    }
                    <Table
                        columns={columns2}
                        dataSource={drawerTableData}
                        scroll={{ x: 'max-content' }}
                    />
                    {/* {
                                (actionState === 'edit' && (userRole === "Secretary" || userRole === "Assistant Secretary"))
                                && <Button type='primary' style={{float:'right',}} onClick={showAddPaperCategoryDrawer}>Add Paper Category</Button>
                    } */}
                    {
                        (actionState === 'edit' && 
                            isSelectedCommitteeOwner
                        ) && 
                        <Button 
                            type='primary' 
                            style={{float:'right',}} 
                            onClick={showAddPaperCategoryDrawer}
                        >
                            Add Paper Category
                        </Button>
                    }
                    {
                        (
                            (actionState === 'edit' || actionState === 'view') && 
                            isSelectedCommitteeOwner
                        ) && (
                            
                            <Table
                                columns={paperCategoryTableColumns}
                                dataSource={paperCategoryTableData}
                                scroll={{ x: 'max-content' }}
                            />
                        )
                    }
                    <Drawer
                        title="Add New Members"
                        // closable={false}
                        onClose={onChildrenDrawerClose}
                        open={childrenDrawer}
                        size='large'
                        footer={[
                            <Flex justify='flex-end' align='center' gap='large'>
                                <Button onClick={onChildrenDrawerClose}>
                                    Cancel
                                </Button>
                                <Button type="primary" onClick={handleAddMembers} disabled={selectedRow.length === 0}>
                                    Add
                                </Button>
                            </Flex>
                        ]
                        }
                    >
                        <Form layout="vertical" form={addNewMemberForm}>
                            <Row>
                                <Col span={24}>
                                    <Form.Item label="Branch" name="selectedBranch">
                                        <Select
                                            showSearch
                                            options={branchList}
                                            placeholder="Select a branch"
                                            // allowClear={true}
                                            onChange={(value) => {
                                                setPaginationOnMemberTable({ current: 1, pageSize: 10 });
                                                setSelectedBranchId(value);
                                            }}
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                        {isBranchMembersLoading ? (<>
                            <CommonSkeletonLoader />
                        </>) : (<>
                            <Table
                                rowSelection={{
                                    type: selectionType,
                                    ...rowSelection,
                                }}
                                columns={columns3}
                                
                                dataSource={newMemberData}
                                pagination={{
                                    ...paginationOnMemberTable,                                    
                                    onChange: (page) => setPaginationOnMemberTable({ ...paginationOnMemberTable, current: page })
                                }}
                                scroll={{ x: 'max-content' }}
                            />
                        </>)}
                    </Drawer>

                    <Drawer
                        title={paperCategoryActionState === 'add' ? "Add New Paper Category" : paperCategoryActionState === "view" ? "View Paper Category" : "Update Paper Category"}
                        closable={true}
                        onClose={onAddPaperCategoryDrawerClose}
                        open={addPaperCategoryDrawer}
                        size='large'
                        footer={[
                            <Flex justify='flex-end' align='center' gap='large'>
                                <Button onClick={onAddPaperCategoryDrawerClose} disabled={paperCategoryActionState === 'view'}>
                                    Cancel
                                </Button>
                                {
                                    paperCategoryActionState === 'add' ? (
                                        <>
                                            <Button type="primary" onClick={handlePaperCategoryForm} disabled={paperCategoryActionState === 'view'} loading={saveButtonLoading}>
                                                {paperCategoryActionState === 'add' ? "Add" : "Update"}
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            <Popconfirm
                                                title={`Do you want to ${paperCategoryActionState === "add" ? "create" : "update"} the paper category?`}
                                                open={showSecondPopconfirm}
                                                onConfirm={() => handlePaperCategorySave()}
                                                onCancel={() => {
                                                    setShowSecondPopconfirm(false)
                                                    openNotificationWithIcon('error', 'Abort', `${paperCategoryActionState === "add" ? "Create" : "Update"} cancelled`, 'bottomLeft')
                                                }}
                                                okText="Yes"
                                                cancelText="No"
                                            >
                                                <Button type="primary" onClick={handlePaperCategoryForm} disabled={paperCategoryActionState === 'view'}>
                                                    {paperCategoryActionState === 'add' ? "Add" : "Update"}
                                                </Button>
                                            </Popconfirm>
                                        </>
                                    )
                                }
                            </Flex>
                        ]
                        }
                    >
                        <Form layout='vertical' form={addNewPaperCategoryForm}>
                            <Row>
                                <Col span={24}>
                                    <Form.Item
                                        validateStatus={errors.paperCategoryOrder ? 'error' : ''}
                                        help={errors.paperCategoryOrder || ""}
                                        label="Order"
                                        requiredz
                                    >
                                        <InputNumber
                                            // min={1} max={100} 
                                            style={{ width: '100%' }}
                                            onChange={(value) => {
                                                const validateData = {
                                                    paperCategoryOrder: value
                                                }
                                                validateFormData(validateData)
                                                setPaperCategoryPayload(prev => ({
                                                    ...prev,
                                                    order: value
                                                }))
                                            }}
                                            value={paperCategoryPayload["order"]}
                                            // value={paperCategoryPayload["order"]}
                                            autoComplete='new-name'
                                            disabled={paperCategoryActionState === 'view'}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <Form.Item
                                        validateStatus={errors.paperCategoryName ? 'error' : ''}
                                        help={errors.paperCategoryName || ""}
                                        label="Paper Category Name"
                                        required
                                    >
                                        <Input
                                            placeholder='Enter paper category name'
                                            onChange={(e) => {
                                                const validateData = {
                                                    paperCategoryName: e.target.value
                                                }
                                                validateFormData(validateData)
                                                setPaperCategoryPayload(prev => ({
                                                    ...prev,
                                                    name: e.target.value
                                                }))
                                            }}
                                            value={paperCategoryPayload["name"]}
                                            autoComplete='new-name'
                                            disabled={paperCategoryActionState === 'view'}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Drawer>
                </Drawer>
                <Drawer
                    title="View Committee Details"
                    onClose={onCloseViewCommittee}
                    open={openViewCommittee}
                    size='large'
                >
                    {isSingleCommitteeDataLoading ? (<><CommonSkeletonLoader /> </>) : (<>
                        <Row gutter={[16, 16]}>
                            <Col span={12}>
                                <Text type="secondary">Committee Name</Text>
                                <div><Text strong>{payload.name || 'N/A'}</Text></div>
                            </Col>
                            <Col span={12}>
                                <Text type="secondary">Committee Type</Text>
                                <div><Text strong>{committeeData.find(c => c.value === payload.committeeTypeId)?.label || 'N/A'}</Text></div>
                            </Col>
                            <Col span={12}>
                                <Text type="secondary">Secretary</Text>
                                <div><Text strong>{secretaryList.find(s => s.value === payload.secretaryId)?.label || 'N/A'}</Text></div>
                            </Col>
                            <Col span={12}>
                                <Text type="secondary">Assistant Secretary</Text>
                                <div><Text strong>{assistantSecUserList.find(a => a.value === payload.assistantSecretaryId)?.label || 'N/A'}</Text></div>
                            </Col>
                            <Col span={24}>
                                <Text type="secondary">Committee Description</Text>
                                <div><Text strong>{payload.description || 'N/A'}</Text></div>
                            </Col>
                            <Col span={12}>
                                <Text type="secondary">Created Date</Text>
                                <div><Text strong>{payload.created_at ? payload.created_at : 'N/A'}</Text></div>
                            </Col>
                            <Col span={12}>
                                <Text type="secondary">Status</Text>
                                <div style={{ marginTop: 8 }}>
                                    {payload["status"] ? (
                                        <Tag color="purple" style={{ width: 90, textAlign: "center" }}>
                                            Active
                                        </Tag>
                                    ) : (
                                        <Tag color="warning" style={{ width: 90, textAlign: "center" }}>
                                            Inactive
                                        </Tag>
                                    )}
                                </div>
                            </Col>
                            <Col span={24}>
                                <div>
                                    <Table
                                        columns={columns2}
                                        dataSource={drawerTableData}
                                        pagination={false}
                                        scroll={{ x: 'max-content' }}
                                    />
                                </div>
                            </Col>
                            {/* {(userRole === "Secretary" || userRole === "Assistant Secretary") && ( */}
                            {(isSelectedCommitteeOwner) && (
                                <Col span={24}>
                                    <div>
                                        <Table
                                            columns={paperCategoryTableColumns}
                                            dataSource={paperCategoryTableData}
                                            pagination={false}
                                            scroll={{ x: 'max-content' }}
                                        />
                                    </div>
                                </Col>
                            )}
                        </Row>
                    </>)}
                </Drawer>
                <Drawer
                    title="Committee Member"
                    // closable={false}
                    onClose={onSingleMemberDrawerClose}
                    open={committeeMemberDrawer}
                    zIndex={1100}
                >
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Text type="secondary">Member Name</Text>
                            <div><Text strong>{committeeMembers["name"] !== "" ? committeeMembers["name"] : 'N/A'}</Text></div>
                        </Col>
                        <Col span={24}>
                            <Text type="secondary">Email</Text>
                            <div><Text strong>{committeeMembers["email"] !== "" ? committeeMembers["email"] : 'N/A'}</Text></div>
                        </Col>
                        <Col span={24}>
                            <Text type="secondary">Designation</Text>
                            <div><Text strong>{committeeMembers["designation"] !== "" ? committeeMembers["designation"] : 'N/A'}</Text></div>
                        </Col>
                        <Col span={24}>
                            <Text type="secondary">Company Name</Text>
                            <div><Text strong>{committeeMembers["companyName"] !== "" ? committeeMembers["companyName"] : 'N/A'}</Text></div>
                        </Col>
                        <Col span={24}>
                            <Text type="secondary">User Role</Text>
                            <div><Text strong>{committeeMembers["roleList"] !== "" ? committeeMembers["roleList"] : 'N/A'}</Text></div>
                        </Col>
                        {/* <Col span={24}>
                            <Text type="secondary">Department</Text>
                            <div><Text strong>{committeeMembers["department"] !== "" ? committeeMembers["department"] : 'N/A'}</Text></div>
                        </Col> */}
                        <Col span={24}>
                            <Text type="secondary">Address</Text>
                            <div><Text strong>{committeeMembers["companyAddress"] !== "" ? committeeMembers["companyAddress"] : 'N/A'}</Text></div>
                        </Col>
                        <Col span={24}>
                            <Text type="secondary">Mobile Number</Text>
                            <div><Text strong>{committeeMembers["mobileNumber"] !== null ? committeeMembers["mobileNumber"] : 'N/A'}</Text></div>
                        </Col>
                    </Row>
                </Drawer>
                <FilterComponent
                    openDrawer={openFIlter}
                    closeDrawer={onCloseFilter}
                    data={tempManageCommitteeTableData}
                    handleFilterDetailsChange={setFilterValues}
                    filterValues={filterValues}
                    screenName="committee_management"
                    resetFilterValues={() => setFilterValues([])}
                />
                {contextHolder}
            </div >
        </>
    )
}